import { createContext, useContext } from "react";

export type TVerificationDetails = {
  isVerified: boolean;
  verified_by: string;
  verified_on: string;
  type: string;
  source: string;
}

interface ExpertProfile {
  apiData:any
  verificationDetails:TVerificationDetails
  setVerificationDetails: React.Dispatch<React.SetStateAction<TVerificationDetails>>;
}
export const ExpertProfileContext = createContext<ExpertProfile | null>(
  null
);

export const useExpertProfileContext = () => {
  const context = useContext(ExpertProfileContext);

  if (!context) {
    throw new Error(
      "useExpertProfileContext must be used within a ExpertProfileContextProvider"
    );
  }

  return context;
};
